const nested = (o, path) =>
  path.split('.').reduce((prev, curr) => (prev ? prev[curr] : undefined), o)

export default nested
